import React from "react";
import API from "@/apis";

import { message, Row, Col, Tooltip, Divider } from "antd";

import { Link, Switch, Route } from "react-router-dom";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import MyIcon from "@/components/MyIcon";
import { CoinGroup, CoinHelper, powerUnitObject } from "@/utils";
import _ from "lodash";
import { project, tempActivity } from "@/config.json";
import ZeroRate from "@/components/ZeroRate";
import { QuestionCircleFilled } from "@ant-design/icons";

interface StoreProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}
interface SubMinerProps {
  summary: any;
  [x: string]: any;
}

interface Props extends StoreProps, SubMinerProps {}
@inject("session", "locale", "router")
@observer
class SummaryData extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  state = {} as any;

  render() {
    const { locale, summary, isSub, isMain, session } = this.props;
    const power = _.isEmpty(summary)
      ? { value: "loading", unit: "TH/s" }
      : powerUnitObject(summary.hashRate, summary.currency);
    const powerDay = _.isEmpty(summary)
      ? { value: "loading", unit: "TH/s" }
      : powerUnitObject(summary.hashRateDay, summary.currency);
    const isMainSummary = _.isBoolean(isMain)
      ? locale.get("IndexPage.mainEarnTip") + "\n" + locale.get("IndexPage.Last24hoursTips")
      : locale.get("IndexPage.Last24hoursTips");
    const isLTC = summary.currency && summary.currency == "LTC";

    return (
      <div className="summary-data">
        <Row gutter={16}>
          <Col className="gutter-row" span={6}>
            <div className="gutter-box">
              {/* <div className={`color-block color-block1-${project}`}></div> */}
              <div className="top">
                <span className="top-title">
                  {isSub ? locale.get("power") : locale.get("IndexPage.totalHashrates")}
                </span>
                <Tooltip
                  placement="top"
                  title={
                    isSub
                      ? locale.get("IndexPage.SubHashratesTips")
                      : locale.get("IndexPage.totalHashratesTips")
                  }
                >
                  <QuestionCircleFilled className="icon-size" />
                </Tooltip>
              </div>
              <div className="bottom-list">
                <div className="bottom-block">
                  <span className="bottom-title">{locale.get("IndexPage.realTime")}</span>
                  <div className="bottom-content">
                    <span className="memepool-number-font">{power.value}</span>
                    <span className="span-unit">&nbsp;{power.unit}</span>
                  </div>
                </div>
                <div className="border-line"></div>
                <div className="bottom-block">
                  <span className="bottom-title">{locale.get("IndexCharts.24hour")}</span>
                  <div className="bottom-content">
                    <span className="memepool-number-font">{powerDay.value}</span>
                    <span className="span-unit">&nbsp;{powerDay.unit}</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="gutter-row" span={6}>
            <div className="gutter-box">
              {/* <div className={`color-block color-block2-${project}`}></div> */}
              <div className="top">
                <span className="top-title">
                  {isSub ? locale.get("IndexPage.miner") : locale.get("IndexPage.totalMiners")}
                </span>
                <Tooltip
                  placement="top"
                  overlayStyle={{ whiteSpace: "pre-line" }}
                  title={
                    (isSub
                      ? locale.get("IndexPage.SubMinersTips1")
                      : locale.get("IndexPage.totalMinersTips1")) +
                    "\n" +
                    locale.get("IndexPage.totalMinersTips2") +
                    "\n" +
                    locale.get("IndexPage.totalMinersTips3") +
                    "\n" +
                    locale.get("IndexPage.totalMinersTips4")
                  }
                >
                  <QuestionCircleFilled className="icon-size" />
                </Tooltip>
              </div>
              <div className="bottom-list">
                <div className="bottom-block">
                  <span className="bottom-title">{locale.get("IndexPage.online")}</span>
                  <div className="bottom-green memepool-number-font">{summary.onlineWorker}</div>
                </div>
                <div className="border-line"></div>
                <div className="bottom-block">
                  <span className="bottom-title">{locale.get("IndexPage.low")}</span>
                  <div className="bottom-yellow memepool-number-font">{summary.lowWorker}</div>
                </div>
                <div className="border-line"></div>
                <div className="bottom-block">
                  <span className="bottom-title">{locale.get("IndexPage.offline")}</span>
                  <div className="bottom-red memepool-number-font">{summary.offlineWorker}</div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="gutter-row" span={6}>
            <div className="gutter-box">
              {/* <div className={`color-block color-block3-${project}`}></div> */}
              <div className="top">
                <span className="top-title">{locale.get("IndexPage.Last24hours")}</span>
                <Tooltip
                  placement="top"
                  overlayStyle={{ whiteSpace: "pre-line" }}
                  title={isMainSummary}
                >
                  <QuestionCircleFilled className="icon-size" />
                </Tooltip>
              </div>
              <div className="bottom-list">
                <div className="bottom-block">
                  <span className="bottom-title">{CoinGroup(summary.currency)[0]}</span>
                  <div className="bottom-content memepool-number-font">
                    {CoinHelper.amount2bsv(!isLTC ? summary.btcProfitDay : summary.ltcProfitDay)}
                  </div>
                </div>
                <div className="border-line"></div>
                <div className="bottom-block">
                  <span className="bottom-title">{CoinGroup(summary.currency)[1]}</span>
                  <div className="bottom-content memepool-number-font">
                    {CoinHelper.amount2bsv(!isLTC ? summary.bsvProfitDay : summary.dogeProfitDay)}
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="gutter-row" span={6}>
            <div className="gutter-box">
              {/* <div className={`color-block color-block4-${project}`}></div> */}
              <div className="top">
                <span className="top-title">{locale.get("IndexPage.todayEstimate")}</span>
                <Tooltip placement="top" title={locale.get("IndexPage.todayEstimateTip")}>
                  <QuestionCircleFilled className="icon-size" />
                </Tooltip>
              </div>
              <div className="bottom-list">
                <div className="bottom-block">
                  <span className="bottom-title">{CoinGroup(summary.currency)[0]}</span>
                  <div className="bottom-content memepool-number-font">
                    {CoinHelper.amount2bsv(
                      !isLTC ? summary.btcProfitPredict : summary.ltcProfitPredict
                    )}
                  </div>
                </div>
                <div className="border-line"></div>
                <div className="bottom-block memepool-number-font">
                  <span className="bottom-title">{CoinGroup(summary.currency)[1]}</span>
                  <div className="bottom-content">
                    {CoinHelper.amount2bsv(
                      !isLTC ? summary.bsvProfitPredict : summary.dogeProfitPredict
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SummaryData as React.ComponentType<SubMinerProps>;
